import React, { useEffect, useState } from "react";
import InputBar from "components/InputBar/InputBar";
import Button from "components/Button/Button";
import Timer from "components/Timer/Timer";
import Logo from "assets/icons/AppCrash.png";
import { Link } from "react-router-dom";
import OtpSelector from "components/OtpSelector/OtpSelector";
import { withRouter } from "react-router";
import { APP_ROUTES } from "constants/routes";
import { API_KEYS } from "constants/apiEndpoints";
import { requestPostFetchApi } from "utils/apiMethods";
import { isMobileNumberIndian } from "utils/validations";
import { OTP_LENGTH, RESEND_OTP_TIME } from "constants/constants";
import StateLogo from "../../assets/icons/Fabpiks.png";
import {
  getMobileNumberWithCountryCode,
  getUserPhone,
  getVendingMachineUuid,
} from "utils/commonMethods";
import useAuthentication from "hooks/useAuthentication";
import withToasts from "hoc/withToasts";
import "../../containers/UserDetails/UserDetails.css";
import "components/LoginForm/LoginForm.css";
import { LeftArrowIcon, StartLogo } from "constants/icons";
import { startLogo } from "../../constants/images";
import UserDetailsHeader from "containers/UserDetails/UserDetailsHeader/UserDetailsHeader";
import { requestClientDetails } from "store/actions/clientDetails.action";
import { connect } from "react-redux";

//Handles user login with OTP verifications
function LoginForm({
  showErrorToast,
  showSuccessToast,
  history,
  requestCLdetails,
  clDetails,
}) {
  const [mobileNumber, setMobileNumber] = useState("");
  const [otp, setOtp] = useState("");
  const [showOtpScreen, setShowOtpScreen] = useState(false);
  const [resendOtpEnabled, setResendOtpEnabled] = useState(false);
  const { setUserToken, setUserHashToken } = useAuthentication();

  const componentTexts = window.appTexts.components.login_form;
  const componentTexts1 = window.appTexts.login_page;
  const sendOtpToUser = function () {
    return requestPostFetchApi(API_KEYS.SEND_OTP, {
      companyId: clDetails.companyId,
      phone_no: getMobileNumberWithCountryCode(mobileNumber),
    });
  };
  const continueButton = (
    <Link to={APP_ROUTES.LOGIN.url}>
      <Button>{componentTexts1.add_button_text}</Button>
    </Link>
  );
  const toggleOtpScreen = function () {
    return setShowOtpScreen(!showOtpScreen);
  };

  const mobileNumberChangeHandler = function (name, value) {
    return setMobileNumber(value);
  };

  const handleMobileNumberOtpMiddleware = function (errorToastEnabled = false) {
    //Validates mobile number beforehand.
    if (!isMobileNumberIndian(mobileNumber)) {
      if (errorToastEnabled) {
        showErrorToast(
          componentTexts.invalid_mobile_number_title,
          componentTexts.invalid_mobile_number_description
        );
      }
      return undefined;
    }
    return true;
  };

  const handleMobileNumberOtp = function () {
    if (!handleMobileNumberOtpMiddleware(true)) {
      return;
    }
    return toggleOtpScreen();
  };

  const onResendTimerComplete = function () {
    return setResendOtpEnabled(true);
  };

  const resendOtp = function () {
    return sendOtpToUser().then(() => {
      showSuccessToast(
        componentTexts.otp_resent_title,
        componentTexts.otp_resent_description_prefix +
          mobileNumber +
          componentTexts.otp_resent_description_postfix
      );
      return setResendOtpEnabled(false);
    });
  };

  useEffect(() => {
    requestCLdetails();
  }, []);

  const mobileNumberEditHandler = function () {
    toggleOtpScreen();
  };

  const onOtpChange = function (nextOtp) {
    return setOtp(nextOtp);
  };

  const redirectUserToCheckoutPage = function () {
    return history.push(APP_ROUTES.CHECKOUT_PAGE.url);
  };

  const submitHandlerMiddleware = function (errorToastEnabled = false) {
    if (!otp.length === OTP_LENGTH) {
      if (errorToastEnabled) {
        showErrorToast(
          componentTexts.invalid_otp_title,
          componentTexts.invalid_otp_description
        );
      }
      return undefined;
    }
    return true;
  };
  const submitHandler = function (response) {
    if (!submitHandlerMiddleware(true)) {
      return;
    }
    //Handles otp not verified
    if (!response.otpVerified) {
      //If no attempts are left, send a new otp.
      if (response.otp_verification_attempts === 0) {
        return sendOtpToUser().then(() => {
          return showSuccessToast(
            componentTexts.new_otp_resend_title,
            componentTexts.new_otp_resend_description
          );
        });
      }
      return showErrorToast(
        componentTexts.invalid_otp_title,
        componentTexts.invalid_otp_description +
          response.otp_verification_attempts
      );
    } else {
      setUserToken(response.user);
      setUserHashToken(response);
      if (response.need_extra_data) {
        history.push({
          pathname: APP_ROUTES.USERDETAILS.url,
          state: {
            data: response.required_customer_data,
          },
        });
      } else {
        history.push(APP_ROUTES.HOME_PAGE.url);
      }

      //Redirect user to checkout page.
      // redirectUserToCheckoutPage();
    }
  };

  const verifyOtpRequestBody = {
      sampling_flow: true,
      uuid: getVendingMachineUuid(),
      otp,
      companyId: clDetails.companyId,
      phone_no: getMobileNumberWithCountryCode(mobileNumber),
    },
    sendOtpRequestBody = {
      companyId: clDetails.companyId,
      phone_no: getMobileNumberWithCountryCode(mobileNumber),
    };

  return (
    <React.Fragment>
      {!showOtpScreen ? (
        ""
      ) : (
        <div>
          <div className="flex-container">
            <p style={{ textAlign: "center" }}>
              Experience{" "}
              <em style={{ fontSize: "1.5rem" }}>
                <b>Free Samples</b>
              </em>{" "}
              <br />
              from exciting brands!
            </p>
            <div
              style={{
                borderRadius: "50%",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                marginBottom: "1em",
                width:"65vw",
                maxWidth: "15rem",
                height:"35vh"
              }}
            >
              <img
                src={clDetails.verification_screen_images}
                style={{
                  width: "100%",
                }}
              />
            </div>
          </div>
          <section
            className="flex-container-space-between login-form__info"
            style={{ marginTop: "0px", paddingTop:"0" }}
          >
            <div style={{ display: "flex" }}>
              <span>{mobileNumber}</span>
            </div>
            <div className="edit_number_link">
              <a onClick={() => setShowOtpScreen(false)}>
                {componentTexts.edit_mobile_number}
              </a>
            </div>
          </section>
        </div>
      )}

      <div className="login-form">
        <div className="login-form__input-bar-wrapper">
          {showOtpScreen ? (
            <div>
              <p style={{margin:"auto", textAlign:"center", width:"100%", marginBottom:"1rem", fontSize:"1.2em", fontWeight:"bolder"}}>Enter OTP</p>
            <OtpSelector onChange={onOtpChange} />
            </div>
          ) : (
            <div className="flex-container">
              <p>
                Experience <em style={{ fontSize: "1.5rem" }}>Free Samples</em>{" "}
                <br />
                from exciting brands!
              </p>
              <div
                style={{
                  borderRadius: "50%",
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  margin: "1em 0",
                  width:"50vw",
                  // height:"35vh"
                }}
              >
                <img
                  src={clDetails.verification_screen_images}
                  style={{
                    width: "100%",
                  }}
                />
              </div>

              <div style={{ width: "100%" }}>
                <InputBar
                  name="mobile"
                  type="number"
                  value={mobileNumber}
                  onChange={mobileNumberChangeHandler}
                  inputProps={{
                    placeholder: componentTexts.input_placeholder_before_otp,
                  }}
                />
              </div>
            </div>
          )}
        </div>
        {showOtpScreen && (
          <div className="login-form__resend-otp">
            {!resendOtpEnabled ? (
              <Timer
                concatenateText={componentTexts.resend_otp_waiting}
                seconds={RESEND_OTP_TIME}
                onTimerComplete={onResendTimerComplete}
              />
            ) : (
              <React.Fragment>
                <span>{componentTexts.resend_otp_text_prefix}</span>
                <span
                  className="fcolor--secondary cursor--pointer"
                  onClick={resendOtp}
                >
                  {componentTexts.resend_otp_text}
                </span>
              </React.Fragment>
            )}
          </div>
        )}

        <div className="login-form__actions">
          {showOtpScreen ? (
            <Button
              onClick={submitHandler}
              loaderApiKey={submitHandlerMiddleware() && API_KEYS.VERIFY_OTP}
              apiRequestBody={verifyOtpRequestBody}
            >
              {componentTexts.button_text_after_otp}
            </Button>
          ) : (
            <Button
              loaderApiKey={
                handleMobileNumberOtpMiddleware() && API_KEYS.SEND_OTP
              }
              apiRequestBody={sendOtpRequestBody}
              onClick={handleMobileNumberOtp}
            >
              {componentTexts.button_text_before_otp}
            </Button>
          )}
        </div>
      </div>
    </React.Fragment>
  );
}

LoginForm.propTypes = {};

const mapStateToProps = (state) => ({
  clDetails: state.clDetailsReducer,
});

const mapDispatchToProps = (dispatch) => ({
  requestCLdetails: () => dispatch(requestClientDetails()),
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withToasts(withRouter(LoginForm)));
